<template>
  <div>
    <v-dialog
      v-model="showModal"
      persistent
      fullscreen
    >
      <div class="content-section">
        <h1 class="header-style">
          New Timesheet
        </h1>
        <v-form
          ref="form"
          v-model="isFormValid"
          class="mt-2"
          lazy-validation
        >
          <v-row justify="center">
            <v-expansion-panels
              v-model="panel"
              elevation="0"
              class="expansion-style"
              light
              multiple
            >
              <v-expansion-panel
                v-for="(entry, index) in entries"
                :key="index"
              >
                <v-expansion-panel-header>
                  Timesheet {{ index + 1 }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                      <v-select
                        v-model="entry.selectedProject"
                        light
                        color="#37474F"
                        flat
                        dense
                        :items="projectsList"
                        item-text="name"
                        item-value="id"
                        label="Project*"
                        outlined
                        :rules="[(v) => !!v || 'This field is required']"
                        background-color="#FFF"
                        class="small-select"
                        @input="onProjectChange(entry)"
                      />
                    </v-col>
                    <v-col
                      v-if="canCreateAll"
                      cols="12"
                      class="py-0"
                    >
                      <v-select
                        v-model="entry.selectedUser"
                        light
                        color="#37474F"
                        flat
                        dense
                        multiple
                        :items="entry.userList"
                        item-text="full_name"
                        item-value="app_user_organization_id"
                        label="User*"
                        outlined
                        :rules="[
                          (v) =>
                            (v && v.length > 0) || 'This field is required',
                        ]"
                        background-color="#FFF"
                        class="small-select"
                      />
                    </v-col>
                    <v-col
                      :cols="index === 0 ? '12' : '10'"
                      class="py-0"
                    >
                      <v-select
                        v-model="entry.type"
                        light
                        color="#37474F"
                        flat
                        dense
                        :items="payItems"
                        item-text="name"
                        item-value="id"
                        label="Pay Item"
                        outlined
                        background-color="#FFFFFF"
                        class="small-select"
                        :rules="[(v) => !!v || 'This field is required']"
                      />
                    </v-col>
                    <v-col
                      v-if="entries.length > 1 && index !== 0"
                      cols="2"
                      class="py-0"
                    >
                      <v-btn
                        fab
                        small
                        elevation="0"
                        color="transparent"
                        @click="removeField(index)"
                      >
                        <v-icon color="red">
                          mdi-trash-can-outline
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <v-dialog
                        :ref="'fromDialog'"
                        v-model="entry.startDateCalender"
                        width="290px"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="entry.startDate"
                            label="Start Date"
                            light
                            dense
                            outlined
                            background-color="#FFF"
                            :rules="[(v) => !!v || 'This field is required']"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-if="entry.startDateCalender"
                          v-model="entry.startDate"
                          full-width
                          color="#37474F"
                          light
                          :max="maxStartDate"
                          @change="entry.startDateCalender = false"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="#37474F"
                            @click="entry.startDateCalender = false"
                          >
                            Cancel
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <v-dialog
                        :ref="'fromDialog'"
                        v-model="entry.endDateCalender"
                        width="290px"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="entry.endDate"
                            label="End Date"
                            light
                            dense
                            outlined
                            background-color="#FFF"
                            :rules="[(v) => !!v || 'This field is required']"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-if="entry.endDateCalender"
                          v-model="entry.endDate"
                          full-width
                          color="#37474F"
                          light
                          :min="entry.startDate"
                          :max="maxStartDate"
                          @change="entry.endDateCalender = false"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="#37474F"
                            @click="entry.endDateCalender = false"
                          >
                            Cancel
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <v-dialog
                        ref="dialog"
                        v-model="entry.startTimeModal"
                        persistent
                        width="290px"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="entry.startTime"
                            label="Start Time*"
                            light
                            dense
                            filled
                            outlined
                            color="#000000"
                            background-color="#FFFFFF"
                            :suffix="userTimeZone"
                            :rules="[
                              (v) => !!v || 'Check-out Time is required',
                            ]"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-time-picker
                          v-if="entry.startTimeModal"
                          v-model="entry.timeStart"
                          color="#37474F"
                          light
                          full-width
                          @change="calculateDuration(entry)"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="entry.startTimeModal = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              () => {
                                entry.startTime = entry.timeStart;
                                entry.startTimeModal = false;
                              }
                            "
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <v-dialog
                        ref="dialog"
                        v-model="entry.endTimeModal"
                        persistent
                        width="290px"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="entry.endTime"
                            label="End Time*"
                            light
                            dense
                            filled
                            outlined
                            color="#000000"
                            background-color="#FFFFFF"
                            :suffix="userTimeZone"
                            :rules="[
                              (v) => !!v || 'Check-out Time is required',
                            ]"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-time-picker
                          v-if="entry.endTimeModal"
                          v-model="entry.timeEnd"
                          color="#37474F"
                          light
                          full-width
                          @change="calculateDuration(entry)"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="entry.endTimeModal = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              () => {
                                entry.endTime = entry.timeEnd;
                                entry.endTimeModal = false;
                              }
                            "
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-col>
                    <!-- <v-col
                      cols="6"
                      class="py-0"
                    >
                      <v-text-field
                        v-model="entry.workedHours"
                        type="number"
                        label="Hours*"
                        dense
                        :rules="[(v) => !!v || 'This field is required']"
                        color="#000000"
                        background-color="#FFFFFF"
                        light
                        outlined
                        disabled
                        class="purple-input"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <v-text-field
                        v-model="entry.workedMins"
                        type="number"
                        label="Mins*"
                        dense
                        :rules="[(v) => !!v || 'This field is required']"
                        color="#000000"
                        background-color="#FFFFFF"
                        light
                        outlined
                        disabled
                        class="purple-input"
                      />
                    </v-col> -->
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                      <v-text-field
                        :value="`${entry.workedHours}:${entry.workedMins}`"
                        label="Worked Hours*"
                        dense
                        outlined
                        disabled
                        class="purple-input"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                      <v-text-field
                        v-model="entry.breakDuration"
                        label="Break Duration"
                        placeholder="HH:mm"
                        dense
                        maxlength="5"
                        outlined
                        class="purple-input"
                        :rules="[validateBreakDuration]"
                        @input="formatBreakDuration(entry)"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                      <v-textarea
                        v-model="entry.notes"
                        outlined
                        light
                        class="field-text-style"
                        :counter="100"
                        counter-value-color="red"
                        filled
                        color="#000000"
                        background-color="#FFFFFF"
                        label="Notes"
                        dense
                        rows="2"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-form>
        <v-btn
          class="mt-2 mb-4"
          small
          outlined
          color="#37474F"
          @click="addField"
        >
          <v-icon small>
            mdi-plus
          </v-icon>
          Add Timesheets
        </v-btn>
        <br>
        <v-btn
          class="btn-style"
          color="#64CA7F"
          elevation="0"
          @click="createTimesheets"
        >
          Submit
        </v-btn>
        <v-btn
          class="btn-style grey-button"
          color="#E2E2E2"
          elevation="0"
          @click="showModal = false"
        >
          Cancel
        </v-btn>
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          class="close-button"
          @click="showModal = false"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
      </div>
      <centre-spinner :loading="loading" />
    </v-dialog>
    <alert-dialog
      v-if="showAlertDialog"
      title="Message"
      :message="message"
      confirm-button="Done"
      @confirmed="(showAlertDialog = false), (showModal = false)"
    />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment-timezone';
import Constants from 'src/constants';
import ConfirmDialog from '../../../../components/ConfirmDialog.vue';

export default {
  name: 'TimesheetCreate',
  components: {
    'centre-spinner': spinner,
    'alert-dialog': ConfirmDialog,
  },
  data () {
    return {
      loading: false,
      showModal: true,
      isFormValid: false,
      maxStartDate: moment().format('YYYY-MM-DD'),
      fieldNumbers: 1,
      panel: [0],
      entries: [
        {
          selectedProject: null,
          selectedUser: [],
          userList: [],
          startDateCalender: false,
          endDateCalender: false,
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          workedHours: '00',
          workedMins: '00',
          startTime: moment().hour(7).minute(0).format('HH:mm'),
          endTime: moment().hour(15).minute(0).format('HH:mm'),
          type: '',
          timeStart: moment().format('HH:mm'),
          startTimeModal: false,
          timeEnd: moment().format('HH:mm'),
          endTimeModal: false,
          breakDuration: '00:00',
          notes: '',
        },
      ],
      canCreateAll: false,
      showAlertDialog: false,
      message: '',
    };
  },
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    filterAppUserList () {
      return this.$store.getters['appusers/getFilterAppUsersList'];
    },
    payItems () {
      return this.$store.getters['timesheets/getPayItems'];
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    isBreakEnabled () {
      return this.orgSettings.timesheet_break;
    },
    projectsList () {
      return this.$store.getters['projects/getOrganizationProjects'];
    },
    userTimeZone () {
      var Zone = moment.tz.guess();
      var timezone = moment.tz(Zone).zoneAbbr();
      return timezone;
    },
  },
  watch: {
    entries: {
      handler (newEntries) {
        newEntries.forEach((entry) => {
          this.calculateDuration(entry);
        });
      },
      deep: true,
    },
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    this.loading = true;
    const orgExtId = await this.selectedOrganization.organization.external_id;
    this.checkTimesheetPermissions();
    await this.$store.dispatch('appusers/clearFilterAppUsersList');
    await this.$store.dispatch('projects/fetchOrganizationProjects', {
      organizationExtId: orgExtId,
    });
    await this.fetchPayItems();
    this.entries.forEach((entry) => {
      this.calculateDuration(entry);
    });
    this.loading = false;
  },
  methods: {
    checkTimesheetPermissions () {
      const role = this.selectedOrganization.app_user_role;
      const allPermissions = this.orgSettings.timesheet_permissions;
      let rolePer = null;

      if (allPermissions !== null) {
        switch (role) {
          case 'site-manager':
            rolePer = allPermissions.site_manager;
            break;
          case 'worker':
            rolePer = allPermissions.worker;
            break;
          case 'contractor':
            rolePer = allPermissions.contractor;
            break;
        }
      }
      this.canCreateAll = rolePer.create.all;
      return rolePer;
    },
    formatBreakDuration (entry) {
      let value = (entry.breakDuration || '').replace(/\D/g, '');

      if (value.length > 4) {
        value = value.slice(0, 4);
      }

      if (value.length >= 3) {
        entry.breakDuration = `${value.slice(0, 2)}:${value.slice(2)}`;
      } else {
        entry.breakDuration = value;
      }
    },
    validateBreakDuration (value) {
      if (!value) return true;

      const regex = /^([0-9]{2}):([0-5][0-9])$/;

      return regex.test(value) || 'Break duration must be in HH:mm format';
    },
    async onProjectChange (entry) {
      entry.selectedUser = [];

      if (entry.selectedProject) {
        await this.getFilterAppUsersList(entry.selectedProject, entry);
      }
    },
    async getFilterAppUsersList (projectId, entry) {
      if (this.canCreateAll) {
        this.loading = true;
        await this.$store.dispatch('appusers/fetchFilterAppUsersList', {
          orgExternalId: this.selectedOrganization.organization.external_id,
          params: {
            params: {
              requestStatus: ['accepted'],
              projectId: projectId,
              tracking: true,
              activeStatus: true,
            },
          },
        });
        entry.userList = this.$store.getters[
          'appusers/getFilterAppUsersList'
        ].map((u) => ({
          ...u,
          full_name: `${u.first_name} ${u.last_name}`,
        }));

        this.loading = false;
      }
    },
    addField () {
      this.entries.push({
        selectedProject: null,
        selectedUser: [],
        userList: [],
        startDateCalender: false,
        endDateCalender: false,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        workedHours: '00',
        workedMins: '00',
        breakTimeHours: '00',
        breakTimeMins: '00',
        startTime: moment().hour(7).minute(0).format('HH:mm'),
        endTime: moment().hour(15).minute(0).format('HH:mm'),
        type: '',
        timeStart: moment().format('HH:mm'),
        startTimeModal: false,
        timeEnd: moment().format('HH:mm'),
        endTimeModal: false,
        notes: '',
      });
      this.fieldNumbers = this.entries.length;
      this.panel = [this.entries.length - 1];
    },
    removeField (index) {
      if (index > 0) {
        this.panel = [index - 1];
      } else {
        this.panel = [0];
      }
      this.entries.splice(index, 1);
    },
    async fetchPayItems () {
      await this.$store.dispatch('timesheets/fetchPayItems', {
        orgExtId: this.selectedOrganization.organization.external_id,
      });
    },
    async createTimesheets () {
      const invalidPanels = [];

      this.entries.forEach((entry, idx) => {
        const hours = Number(entry.workedHours) || 0;
        const mins = Number(entry.workedMins) || 0;

        if (hours === 0 && mins === 0) {
          invalidPanels.push(idx);
        }
      });

      if (invalidPanels.length > 0) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please enter valid worked time.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );

        this.panel = invalidPanels;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        const invalidPanels = [];
        this.entries.forEach((entry, idx) => {
          if (
            !entry.selectedProject ||
            !entry.startDate ||
            !entry.endDate ||
            (entry.workedHours === '00' && entry.workedMins === '00')
          ) {
            invalidPanels.push(idx);
          }
        });
        this.panel = invalidPanels.length ? invalidPanels : this.panel;
        return;
      }
      this.loading = true;
      await this.$store
        .dispatch('timesheets/createTimesheet', {
          externalId: this.selectedOrganization.organization.external_id,
          data: {
            time_types: this.entries
              .map((entry) => {
                const totalHours = String(entry.workedHours || '00').padStart(
                  2,
                  '0',
                );
                const totalMins = String(entry.workedMins || '00').padStart(
                  2,
                  '0',
                );
                const duration = `${totalHours}:${totalMins}`;
                const dateStartTime = moment(
                  `${entry.startDate} ${entry.startTime}`,
                  'YYYY-MM-DD HH:mm',
                )
                  .utc()
                  .format('YYYY-MM-DDTHH:mm:ss[Z]');
                const dateEndTime = moment(
                  `${entry.endDate} ${entry.endTime}`,
                  'YYYY-MM-DD HH:mm',
                )
                  .utc()
                  .format('YYYY-MM-DDTHH:mm:ss[Z]');
                const breakTime = entry.breakDuration || '00:00';
                return {
                  project_id: entry.selectedProject,
                  app_user_organization_ids: this.canCreateAll
                    ? entry.selectedUser
                    : [this.selectedOrganization.app_user_organization_id],
                  pay_item_id: entry.type,
                  hours: duration,
                  start_time: dateStartTime,
                  end_time: dateEndTime,
                  break_time: breakTime,
                  notes: entry.notes || '',
                };
              })
              .filter((entry) => entry.hours !== '00:00'),
          },
        })
        .then((res) => {
          const failedCount = parseInt(res.failed.charAt(0), 10);
          const successCount = parseInt(res.success.charAt(0), 10);
          this.$emit('timesheet-created');
          this.loading = false;
          this.$refs.form.reset();

          if (successCount > 0 && failedCount === 0) {
            this.message = `✅${res.success}`;
            this.showAlertDialog = true;
            // this.$store.dispatch(
            //   'alert/onAlert',
            //   {
            //     message: `✅${res.success}`,
            //     type: Constants.ALERT_TYPE_SUCCESS,
            //     color: 'grey lighten-3',
            //   },
            //   { root: true },
            // );
          }
          if (failedCount > 0 && successCount === 0) {
            this.message = `❌${res.failed}`;
            this.showAlertDialog = true;
            // this.$store.dispatch(
            //   'alert/onAlert',
            //   {
            //     message: `❌${res.failed}`,
            //     type: Constants.ALERT_TYPE_ERROR,
            //     color: 'grey darken-2',
            //   },
            //   { root: true },
            // );
          }
          if (successCount > 0 && failedCount > 0) {
            this.message = `✅${res.success}\n ❌${res.failed}`;
            this.showAlertDialog = true;
            // this.message = `✅ ${res.success}\n ❌${res.failed}`;
            // this.$store.dispatch(
            //   'alert/onAlert',
            //   {
            //     message: this.message,
            //     type: Constants.ALERT_TYPE_CUSTOM,
            //     color: 'grey darken-2',
            //   },
            //   { root: true },
            // );
          }
          // this.showModal = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    calculateDuration (entry) {
      if (
        entry.startDate &&
        entry.startTime &&
        entry.endDate &&
        entry.endTime
      ) {
        const start = moment(
          `${entry.startDate} ${entry.startTime}`,
          'YYYY-MM-DD HH:mm',
        );
        const end = moment(
          `${entry.endDate} ${entry.endTime}`,
          'YYYY-MM-DD HH:mm',
        );

        if (start.isValid() && end.isValid()) {
          let totalMinutes = end.diff(start, 'minutes');

          // Convert break time to minutes if break is enabled
          if (this.isBreakEnabled) {
            const [breakHours, breakMins] = (entry.breakDuration || '00:00')
              .split(':')
              .map(Number);

            const breakTotal = (breakHours || 0) * 60 + (breakMins || 0);

            // Subtract break time, ensuring no negative values
            totalMinutes = Math.max(totalMinutes - breakTotal, 0);
          }

          // Convert back to hours and minutes
          const hours = Math.floor(totalMinutes / 60);
          const mins = totalMinutes % 60;

          entry.workedHours = String(hours).padStart(2, '0');
          entry.workedMins = String(mins).padStart(2, '0');
        } else {
          entry.workedHours = '00';
          entry.workedMins = '00';
        }
      }
    },

    // calculateDuration (entry) {
    //   if (
    //     entry.startDate &&
    //     entry.startTime &&
    //     entry.endDate &&
    //     entry.endTime
    //   ) {
    //     const start = moment(
    //       `${entry.startDate} ${entry.startTime}`,
    //       'YYYY-MM-DD HH:mm',
    //     );
    //     const end = moment(
    //       `${entry.endDate} ${entry.endTime}`,
    //       'YYYY-MM-DD HH:mm',
    //     );

    //     if (start.isValid() && end.isValid()) {
    //       const diffMinutes = end.diff(start, 'minutes');
    //       const hours = Math.floor(diffMinutes / 60);
    //       const mins = diffMinutes % 60;

    //       entry.workedHours = String(hours).padStart(2, '0');
    //       entry.workedMins = String(mins).padStart(2, '0');
    //     } else {
    //       entry.workedHours = '00';
    //       entry.workedMins = '00';
    //     }
    //   }
    // },
  },
};
</script>

<style scoped>
.theme--dark.v-list {
  background-color: white !important;
}

.v-input--selection-controls__input .v-icon {
  color: #ccc !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.theme--dark.v-label {
  color: rgba(255, 255, 255, 0.7);
}

.theme--dark.v-messages {
  color: #37474f !important;
}

.hint-text {
  font-size: 13px;
  color: #444444;
  margin-top: -13px !important;
}

.class-disabled .v-input--selection-controls__input .v-icon {
  color: #000 !important;
}

.expansion-style {
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 25px 10px 5px 10px;
}
</style>
